// The Opportunities column picker's own look, applied on top of TheEye's shared panel styles. TheEye
// portals its panel to the page root, so these rules are global, but every one of them is scoped to
// COLUMN_PICKER_PANEL_CLASS, which only the Opportunities picker passes (TheEye `panelClassName`): the
// pickers on the other lists keep the shared look untouched.
//
// A wider panel with taller rows, larger text in the main text colour, and a neutral grey hover that keeps
// the text colour, instead of the shared panel's purple. The custom fields section's rows and fly-out rows
// are <li>s inside the same panel, so they pick up the same row height, text and hover.
import {createGlobalStyle} from 'styled-components';
import {tokensForThemeProvider} from '@forecast-it/design-system';

export const COLUMN_PICKER_PANEL_CLASS = 'opportunity-column-picker';
export const COLUMN_PICKER_PANEL_WIDTH_PX = 300;
// A row: 8px padding top and bottom around the 22px eye icon.
export const COLUMN_PICKER_ROW_HEIGHT_PX = 38;

const color = tokensForThemeProvider.sky.sys.color;
// The same light grey the monochrome toolbar buttons (the eye trigger among them) use on hover.
export const COLUMN_PICKER_HOVER_BACKGROUND =
	tokensForThemeProvider.sky.comp.button.color.background.midemphasismonochrome.hover;

const PANEL = `.board-card-details-selector-list.${COLUMN_PICKER_PANEL_CLASS}`;

export const ColumnPickerPanelStyle = createGlobalStyle`
	${PANEL} {
		font-size: 15px;
		color: ${color.text.content.main};

		li {
			padding: 8px 16px;
		}
		// Options (focusable rows) get the grey hover; headings and dividers are not options.
		li[tabindex]:not(.disabled):hover,
		li[tabindex]:not(.disabled):focus {
			color: ${color.text.content.main};
			background-color: ${COLUMN_PICKER_HOVER_BACKGROUND};
		}
		li:not([tabindex]):hover {
			color: inherit;
			background-color: transparent;
			cursor: default;
		}

		.name {
			max-width: none;
			min-width: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.eye-section-heading {
			padding: 12px 16px 6px;
			font-size: 12px;
			color: ${color.text.content.auxiliary};
		}
	}
`;
